import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.7638 1H0V3H3.2362L5.96648 13.011L4.71922 18H22V16H7.28078L7.78078 14H19.7208L23.3874 3H5.30925L4.7638 1ZM17 9.5H14.5V12H12.5V9.5H10V7.5H12.5V5H14.5V7.5H17V9.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 19C4.89543 19 4 19.8954 4 21C4 22.1046 4.89543 23 6 23C7.10457 23 8 22.1046 8 21C8 19.8954 7.10457 19 6 19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19Z"}}]};

const CartAddFilled = Vue.extend<IconProps>({
  name: 'CartAddFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cart-add-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CartAddFilled;
